import React, { Fragment } from 'react'
import { Checkbox, Col, DatePicker, Form, Input, InputNumber, Row } from 'antd'
import { get } from 'lodash'
import { dateVal, strVal } from '../../../../modules/Utils'
import CurrencySelect from '../../../../elements/Select/Currency'
import TextArea from 'antd/es/input/TextArea'
import { compose } from 'recompose'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withSubDropdown from '../../../../elements/HOC/withSubDropdown'
import withSort from '../../../../elements/HOC/withSort'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import moment from 'moment'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import { defaultFormItemLayout, rules } from '../../../../modules/FormItems'

const PaymentMethodSelect = compose(
  withSelectFetch({
    dropdown: 'general',
    name: 'paymentMethod',
    cache: true,
  }),
  withSpinning,
  withSort,
)(CustomSelect)

function ClaimItemsForm (props) {
  function disabledDate (current) {
    return current > moment()
  }

  const { getFieldDecorator } = props.form
  const { claimItem, formRef, onChangeReq, ReqGroupSelect, LinesSelect } = props
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 7 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 15 },
    },
  }
  const category = formRef.current && formRef.current.getFieldValue('category')
  const budgetID =
    formRef.current && formRef.current.getFieldValue('budget._id')

  const [BudgetLinesSelect] = useFetchSelectUrl(
    {
      name: 'budgetsLines',
      url: `${budgetID}/lines`,
      cache: false,
      forceFetch: true,
    },
    [budgetID],
  )
  const TypeSelect = compose(
    withSelectFetch({ dropdown: 'claims', name: 'type', forceFetch: true }),
    withSpinning,
    withSubDropdown({ name: strVal({ category }, 'category').toLowerCase() }),
    withSort,
  )(CustomSelect)
  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'No'}>
            {getFieldDecorator('no', {
              initialValue: get(claimItem, 'no'),
              rules: [{ required: true, message: 'No Can\'t be Empty!' }],
            })(<Input style={{ width: '100%' }} placeholder={'No'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Date'}>
            {getFieldDecorator('date', {
              initialValue: dateVal(claimItem, 'date'),
              rules: [{ required: true, message: 'Date Can\'t be Empty!' }],
            })(
              <DatePicker
                disabledDate={disabledDate}
                style={{ width: '100%' }}
                placeholder={'Date'}
                mode={'date'}
              />,
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Amount'}>
            {getFieldDecorator('amount', {
              initialValue: get(claimItem, 'amount'),
              rules: [{ required: true, message: 'Amount Can\'t be Empty!' }],
            })(<InputNumber style={{ width: '100%' }} placeholder={'Amount'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Currency'}>
            {getFieldDecorator('currency.code', {
              initialValue: get(claimItem, 'currency.code'),
              rules: [{ required: true, message: 'Currency Can\'t be Empty!' }],
            })(<CurrencySelect placeholder={'Currency'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Receipt'}>
            {getFieldDecorator('receipt', {
              initialValue: get(claimItem, 'receipt'),
              valuePropName: 'checked',
              rules: [{ required: true, message: 'Receipt Can\'t be Empty!' }],
            })(<Checkbox placeholder={'Receipt'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Method'}>
            {getFieldDecorator('method', {
              initialValue: get(claimItem, 'method'),
              rules: [{ required: true, message: 'Method Can\'t be Empty!' }],
            })(<PaymentMethodSelect placeholder={'Method'}/>)}
          </Form.Item>
        </Col>

        {['Project', 'Internal'].includes(category) && (
          <Fragment>
            <Col span={12}>
              <Form.Item {...formItemLayout} label={'Pre-approved Requisition'}>
                {getFieldDecorator('preapproved', {
                  initialValue: get(claimItem, 'preapproved'),
                  valuePropName: 'checked',
                })(<Checkbox/>)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...formItemLayout} label={'Converted'}>
                {getFieldDecorator('converted', {
                  initialValue: get(claimItem, 'converted'),
                })(
                  <InputNumber
                    style={{ width: '100%' }}
                    placeholder={'Converted'}
                  />,
                )}
              </Form.Item>
            </Col>
          </Fragment>
        )}

        {['Project', 'Internal'].includes(category) &&
        props.form.getFieldValue('preapproved') === true && (
          <Fragment>
            <Col span={12}>
              <Form.Item {...formItemLayout} label={'Requisition'}>
                {getFieldDecorator('requisition._id', {
                  initialValue: get(claimItem, 'requisition._id'),
                })(
                  <ReqGroupSelect
                    onChange={onChangeReq}
                    keyAtr={'_id'}
                    valueAtr={'code'}
                    placeholder={'Requisition'}
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...formItemLayout} label={'Line'}>
                {getFieldDecorator('line._id', {
                  initialValue: get(claimItem, 'line._id'),
                })(
                  <LinesSelect
                    keyAtr={'_id'}
                    valueAtr={'name'}
                    placeholder={'Line'}
                  />,
                )}
              </Form.Item>
            </Col>
          </Fragment>
        )}
        {['Project', 'Internal'].includes(category) &&
        props.form.getFieldValue('preapproved') === true && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Budget Line'}>
              {getFieldDecorator('budgetLine._id', {
                initialValue: get(claimItem, 'budgetLine._id'),
                rules: rules.input,
              })(
                <BudgetLinesSelect
                  data-testid="budgetLine._id"
                  keyAtr={'_id'}
                  valueAtr={'name'}
                />,
              )}
            </Form.Item>
          </Col>
        )}

        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Reason'}>
            {getFieldDecorator('reason', {
              initialValue: get(claimItem, 'reason'),
            })(<Input placeholder={'Reason'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Vendor'}>
            {getFieldDecorator('vendor', {
              initialValue: get(claimItem, 'vendor'),
              rules: [{ required: true, message: 'Vendor Can\'t be Empty!' }],
            })(<Input placeholder={'Vendor'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Description'}>
            {getFieldDecorator('description', {
              initialValue: get(claimItem, 'description'),
            })(<TextArea placeholder={'Description'}/>)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

ClaimItemsForm.propTypes = {}
ClaimItemsForm.defaultProps = {}

export default Form.create()(ClaimItemsForm)
